import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="relative max-w-5xl mx-auto rounded-xl overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20golden%20abstract%20gradient%20background%20with%20soft%20flowing%20lines%2C%20minimal%20elegant%20design%2C%20luxurious%20texture%2C%20cream%20and%20amber%20tones%2C%20professional%20corporate%20aesthetic&width=1200&height=400&seq=cta-bg-91wang&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-primary-500/80"></div>
        </div>
        <div className="relative z-10 py-14 px-6 md:px-12 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
            立即加入91网，开启资源探索之旅
          </h2>
          <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-lg mx-auto">
            500万+用户的选择，3000+优质服务商入驻，海量资源等你来发现
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50 text-primary-600 font-medium rounded-md hover:bg-background-100 transition-colors text-base whitespace-nowrap cursor-pointer"
            >
              免费注册
            </Link>
            <Link
              to="/category/all"
              className="px-8 py-3.5 border border-background-50/40 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-colors text-base whitespace-nowrap cursor-pointer"
            >
              浏览资源
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}